import { createFileRoute, notFound } from "@tanstack/react-router";

import { NotFoundPage } from "@/components/landing/LandingNotFound";
import { cmsPageHead, cmsPageHeaders } from "@/routing/cmsPageRoute";
import McpPage from "./mcp-server/-components/McpPage";
import { mcpServerPageCms } from "./mcp-server/-components/mcpServerSource";

/**
 * The Webshare MCP Server landing page (R-2186). Its sections are the
 * design's own and live in code; every word, link and card icon is the CMS's
 * `mcpServerPage` (R-2398), prerendered as every marketing page is.
 *
 * A sibling of `_app` so the dashboard's guard never sees an anonymous reader
 * here.
 */
export const Route = createFileRoute("/mcp-server")({
  loader: async () => {
    const content = await mcpServerPageCms();
    if (!content) {
      throw notFound();
    }
    return content;
  },
  headers: cmsPageHeaders,
  head: cmsPageHead,
  component: McpServerRoute,
  notFoundComponent: NotFoundPage,
});

function McpServerRoute() {
  return <McpPage content={Route.useLoaderData()} />;
}
